import { Verbiage } from '@infinitro/content';
/** Fixed GMT+7 display (Asia/Bangkok); UTC values in `Date` are unchanged. */
const GMT_PLUS_7 = 'Asia/Bangkok';
function intlLocaleForDates(locale) {
    if (!locale || locale === 'en')
        return 'en-GB';
    if (locale === 'zh')
        return 'zh-CN';
    return locale;
}
/**
 * Formats a UTC instant for promotion UI in GMT+7, e.g. `6 April 2026, 19:00` (matches design comma between date and time).
 */
export function formatInstantInGmtPlus7(date, locale) {
    const dtf = new Intl.DateTimeFormat(intlLocaleForDates(locale), {
        timeZone: GMT_PLUS_7,
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    });
    return dtf.format(date).replace(' at ', ', ');
}
function escapeHtml(text) {
    return text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}
function formatPeriodLineHtml(label, dateTimeLocal, tzSuffix) {
    const dateText = tzSuffix ? `${dateTimeLocal} ${tzSuffix}` : dateTimeLocal;
    return `<span class="promotion-period-range-label">${escapeHtml(label)}</span> <span class="promotion-period-range-value">${escapeHtml(dateText.trim())}</span>`;
}
/**
 * When `description` is null/empty, builds a two-line From/To range in GMT+7 from UTC dates
 * (HTML: labels at 80% opacity via `.promotion-period-range-label`, dates bold at 100% via `.promotion-period-range-value`).
 * Otherwise returns the translated Verbiage string for `description`.
 */
export function resolvePromotionDescriptionDisplay(promo, locale, t) {
    if (promo.description) {
        return t(promo.description);
    }
    const start = promo.startDate ? new Date(promo.startDate) : null;
    if (!start || Number.isNaN(start.getTime())) {
        return t(Verbiage.no_information);
    }
    const tz = promo.showTimezoneSuffixInFallback === false ? '' : t(Verbiage.timezone_gmt_plus_7);
    const fromLineHtml = formatPeriodLineHtml(t(Verbiage.promotion_period_from_label), formatInstantInGmtPlus7(start, locale), tz);
    const end = promo.endDate ? new Date(promo.endDate) : null;
    if (!end || Number.isNaN(end.getTime())) {
        return fromLineHtml;
    }
    const toLineHtml = formatPeriodLineHtml(t(Verbiage.promotion_period_to_label), formatInstantInGmtPlus7(end, locale), tz);
    return `${fromLineHtml}\n${toLineHtml}`;
}
